import { EDA } from "motw_core/Dreams/EDreamAttribute";
import * as React from "react";
import {
    GetDreamAttributeIcon,
    GetDreamAttributeTextColor,
} from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/AttributeMap/AttributeMap";
import { ActiveDreamFilterClass } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/Helpers/ActiveDreamFilterClass";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IDreamsState } from "../../IDreamsState";
import { NavigateToDreamsRoute } from "../../Routing/DreamsRouting";

export function ShowDreamFilter({
    dreams,
    attribute,
    suppressActiveBackground = false,
}: {
    dreams: Dreams;
    attribute: EDA;
    suppressActiveBackground?: boolean;
}) {
    const attributeName = EDA[attribute];
    const attributeOnlyFilters = GetAttributeOnlyFilters(attribute);
    const textColor = GetDreamAttributeTextColor(attribute);

    const dreamCount = dreams
        ? dreams.state.dreamsdata.filter((dream) =>
              dream.attributes.includes(attributeName)
          ).length
        : [];

    const textToDisplay = `${dreamCount} ${attributeName}s`;

    return (
        <span
            id={`show_${attributeName}`}
            style={{ color: textColor }}
            {...(suppressActiveBackground
                ? {}
                : ActiveDreamFilterClass(dreams, attribute))}
        >
            <IconWithText
                iconSuffix={GetDreamAttributeIcon(attribute)}
                whenClicked={() => {
                    NavigateToDreamsRoute(attributeName);
                    dreams.setState(attributeOnlyFilters);
                }}
                displayAsBlock={false}
            >
                {textToDisplay}
            </IconWithText>
        </span>
    );
}

export function LoadDreamsWithAttributeFilter(attribute: EDA) {
    const attributeOnlyFilters = GetAttributeOnlyFilters(attribute);

    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (dreams) {
        NavigateToDreamsRoute(EDA[attribute]);
        dreams.setState(attributeOnlyFilters);
    }
}

export function GetAttributeOnlyFilters(attribute: EDA) {
    return {
        ...clearedDreamFilters,
        selectedAttributes: [EDA[attribute]],
    };
}
